module.exports = __webpack_public_path__ + "static/media/DSCN0329.290cabd8.jpg";